"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.merge = exports.clone = void 0;
// TODO: Handle Arrays
function deepClone(obj) {
    var result = {};
    Object.keys(obj).forEach(function (key) {
        switch (typeof obj[key]) {
            case 'object':
                result[key] = deepClone(obj[key]);
                break;
            default:
                result[key] = obj[key];
        }
    });
    return result;
}
function shallowClone(obj) {
    return __assign({}, obj);
}
function clone(obj, deep) {
    if (deep === void 0) { deep = true; }
    return deep === true ? deepClone(obj) : shallowClone(obj);
}
exports.clone = clone;
// TODO: Handle Arrays
function deepMerge(a, b) {
    var result = {};
    Object.keys(a).forEach(function (key) {
        if (typeof a[key] === 'object') {
            result[key] = b[key] === undefined ? a[key] : merge(a[key], b[key]);
        }
        else {
            result[key] = b[key] === undefined ? a[key] : b[key];
        }
    });
    // values that only exist on b need to be inserted afterwards
    Object.keys(b).forEach(function (key) {
        if (a[key] === undefined) {
            result[key] = b[key];
        }
    });
    return result;
}
function shallowMerge(a, b) {
    return __assign(__assign({}, a), b);
}
function merge(a, b, deep) {
    if (deep === void 0) { deep = true; }
    return deep === true ? deepMerge(a, b) : shallowMerge(a, b);
}
exports.merge = merge;
exports.default = {
    merge: merge,
    clone: clone
};
